import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';

export default function InstitutionList({ match }) {
    
    const fields = [
        { name: 'Name', key: 'name' },
        { name: 'Code', key: 'code' },
        { name: 'Country', keys: ['country', 'name'] },
    ];

    return (
        <ListCRUD
            plural='institutions'
            singular='institution'
            fields={fields}
            match={match}
            disableViewButton
        />
    );
}